import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { Send } from "lucide-react";

export default function ContactForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const validate = () => {
    const errs = {};
    if (!form.name.trim()) errs.name = t("contact.errorName");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) errs.email = t("contact.errorEmail");
    if (form.message.trim().length < 10) errs.message = t("contact.errorMessage");
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  return (
    <form className="contact-form" onSubmit={onSubmit} noValidate data-testid="contact-form">
      <div className="contact-form__row">
        <label htmlFor="cf-name">{t("contact.name")}</label>
        <input
          id="cf-name"
          name="name"
          type="text"
          autoComplete="name"
          placeholder={t("contact.namePh")}
          value={form.name}
          onChange={onChange}
          data-testid="contact-name"
        />
        {errors.name && <span className="contact-form__error">{errors.name}</span>}
      </div>
      <div className="contact-form__row">
        <label htmlFor="cf-email">{t("contact.email")}</label>
        <input
          id="cf-email"
          name="email"
          type="email"
          autoComplete="email"
          placeholder={t("contact.emailPh")}
          value={form.email}
          onChange={onChange}
          data-testid="contact-email"
        />
        {errors.email && <span className="contact-form__error">{errors.email}</span>}
      </div>
      <div className="contact-form__row">
        <label htmlFor="cf-message">{t("contact.message")}</label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          placeholder={t("contact.messagePh")}
          value={form.message}
          onChange={onChange}
          data-testid="contact-message"
        />
        {errors.message && <span className="contact-form__error">{errors.message}</span>}
      </div>
      <p className="contact-form__consent">{t("contact.consent")}</p>
      <button type="submit" className="btn btn--primary btn--full" disabled={submitting} data-testid="contact-submit">
        <Send size={16} aria-hidden="true" />
        <span>{t("contact.submit")}</span>
      </button>
    </form>
  );
}
